import navIcon from '../../../assets/images/landing-images/nav-icon.svg';
import mainLandingImg from '../../../assets/images/landing-images/landing-pic-1.png';
import palmCofee from '../../../assets/images/landing-images/ice-cofee-palm-sugar.svg';
import greenCofee from '../../../assets/images/landing-images/ice-cofee-green-tea.svg';
import hinamiCofee from '../../../assets/images/landing-images/hinami-latte.svg';
import clepponCofee from '../../../assets/images/landing-images/cleppon-cofee.svg';

import bubleTea from '../../../assets/images/topping/buble-tea-gelatin-tea.svg';
import manggo from '../../../assets/images/topping/manggo.svg';
import greenCoconut from '../../../assets/images/topping/green-coconut.svg';
import bobbaManggo from '../../../assets/images/topping/boba-manggo.svg';
import blueberryBobba from '../../../assets/images/topping/blueberry-bobba.svg';
import kiwiPearl from '../../../assets/images/topping/kiwi-pearl.svg';
import matchaCataloppe from '../../../assets/images/topping/matcha-cantalope.svg';
import strawberry from '../../../assets/images/topping/strawberry.svg';

import profile from '../../../assets/images/user/profile.svg';
import qrTransaction from '../../../assets/images/user/qr-transaction.svg';
import productTransaction from '../../../assets/images/user/product-transaction.svg';
import TransactionIcon from '../../../assets/images/user/transaction-icon.svg';

import basket from '../../../assets/images/user/basket.svg';
import user from '../../../assets/images/user/User.svg';

import profileIcon from '../../../assets/icons/popUp/user.svg'
import logOutIcon from '../../../assets/icons/popUp/logout.svg'
import addProduct from '../../../assets/icons/popUp/addProduct.svg'
import addToping from '../../../assets/icons/popUp/addToping.svg'
import transaction from '../../../assets/icons/popUp/transaction.png'



const landingImages={navIcon ,mainLandingImg, palmCofee,greenCofee,hinamiCofee,clepponCofee};
const topingImages={bubleTea ,manggo , greenCoconut, bobbaManggo ,blueberryBobba ,kiwiPearl,matchaCataloppe,strawberry};
const userImages={navIcon,profile,qrTransaction,productTransaction,TransactionIcon};
const headerUserImage={basket,user};
const popImage={profileIcon,logOutIcon,addProduct,addToping,transaction};

export {landingImages,topingImages,userImages,headerUserImage,popImage};